export interface ISddEnrollmentInitiate {
	customerId: string
	title: string
	firstName: string
	lastName: string
	emailAddress: string
	phoneNumber: string
	distributionChannel: OtpDistributionChannel
	market: Market
}

export interface ISddEnrollmentAuthenticate {
	sessionId: string
	customerId: string
	otpCode: string
}

export interface ISddEnrollmentCompleteResponse {
	mandateDocument: number
	mandateDocumentId: string
}

export interface IOtpSessionResponse {
	distributionChannel: OtpDistributionChannel
	otpDistributedToContactInfo: string
	sessionId: string
	expiryAtUtc: string
}

export interface ICompleteSddEnrollmentRequest {
	sessionId: string
	customerId: string
	otpCode: string
	debtorIban: string
	debtorBic: string
	sddWithdrawalType: SddWithdrawalType
	withdrawalAmount: number
}

export interface IResendOtpRequest {
	sessionId: string
	customerId: string
	title: string
	firstName: string
	lastName: string
	emailAddress: string
	phoneNumber: string
	distributionChannel: OtpDistributionChannel
	market: Market
}

export interface IBankInfoProps {
	senderIban: string
	senderBic: string
}

export interface ISddEligible {
	eligible: boolean
	activeMandate: boolean | null
}

export interface ISddMandate {
	id: number
	signDate: string
	validFromDate: string
	validToDate: string
	state: SddState
	stateComment: string
	withdrawalType: SddWithdrawalType
	withdrawalAmount: number
	mandateDocumentId: string
	partyId: string
	debtorIban: string
	debtorName: string
	debtorBic: string
}

export enum SddState {
	Active = 'Active',
	Obsolete = 'Obsolete',
	Expired = 'Expired',
	Inactive = 'Inactive',
	Enrolled = 'Enrolled'
}

export enum OtpDistributionChannel {
	Unknown = 'Unknown',
	Email = 'Email',
	SMS = 'SMS',
	PushNotification = 'PushNotification',
}

export enum Market {
	Global = 'Global',
	Poland = 'Poland',
	Sweden = 'Sweden',
	Finland = 'Finland',
	Norway = 'Norway',
	Estonia = 'Estonia',
	Latvia = 'Latvia',
	Germany = 'Germany',
	Austria = 'Austria',
	Lithuania = 'Lithuania',
	Spain = 'Spain',
}

export enum SddWithdrawalType {
	Unknown = 'Unknown',
	Minimum = 'Minimum',
	Fixed = 'Fixed',
	Full = 'Full',
}
